module.exports = __webpack_public_path__ + "img/cr2_1.fc73ae57.png";